import {
  cleartaxAxios,
  mpBackendAxios,
  websiteUtilityAxios,
  websiteUtilityServerAxios,
} from '../../../http-common';
import { setSessionCookie } from '../../../utils/cookieUtils';
import { API_AUTH_TOKEN } from '../../../env-vars.constants';
import { PARTNER_META_KEY } from '../constants';
import { IFintooResponse, IPartnerPlanData } from '../types';
import { transformPartnerPlanData } from '../utils/partner.transformer';

class PartnerPageDataService {
  getPartnerPageBySlug(slug: string) {
    return websiteUtilityServerAxios.get(`/api/partner-pages/page/${slug}`, {
      headers: {
        Authorization: `Bearer ${API_AUTH_TOKEN}`,
      },
    });
  }

  getAllPartnerPages() {
    return websiteUtilityAxios.get(`/api/partner-pages/page/all`, {
      headers: {
        Authorization: `Bearer ${API_AUTH_TOKEN}`,
      },
    });
  }
  getPricingForCards(listing_id: string, coupon_code: string) {
    return cleartaxAxios.get(
      `/wg-routes/cms/api/v1/product/price?listing_id=${listing_id}&coupon_code=${coupon_code}`
    );
  }
  getPricingForSelfFiling(listing_id: string) {
    const body = {
      requestData: {
        listing_id: listing_id,
        couponCode: null,
        defaultCouponApplied: true,
        couponParams: {},
      },
    };
    return cleartaxAxios.post(
      '/services/app/api/v1/ct-order/product_coupon',
      body
    );
  }
  sendBlackDownloadLink(phone: string) {
    const data = {
      phone_number: phone,
    };
    return cleartaxAxios.post('/f/kramer/black-sms', data);
  }

  getMetaData() {
    return websiteUtilityAxios.get(
      `/api/partner-pages/meta/${PARTNER_META_KEY}`,
      {
        headers: {
          Authorization: `Bearer ${API_AUTH_TOKEN}`,
        },
      }
    );
  }

  getMetaDataServerSide() {
    return websiteUtilityServerAxios.get(
      `/api/partner-pages/meta/${PARTNER_META_KEY}`,
      {
        headers: {
          Authorization: `Bearer ${API_AUTH_TOKEN}`,
        },
      }
    );
  }

  getMetaDataMulti(query: string) {
    return websiteUtilityServerAxios
      .get(`/api/partner-pages/meta?keys=${query}`, {
        headers: {
          Authorization: `Bearer ${API_AUTH_TOKEN}`,
        },
      })
      .then((res) => res.data);
  }

  getPlanData(
    planIds: string[],
    partnerSlug: string
  ): Promise<IPartnerPlanData[]> {
    try {
      if (!planIds.length) return Promise.resolve([]);
      return mpBackendAxios
        .get(`price/partner_slug/${partnerSlug}?plan_id=${planIds.join(',')}`)
        .then((data) => {
          return transformPartnerPlanData(data.data);
        });
    } catch (e) {
      return Promise.resolve([]);
    }
  }

  fintooSignup(user_id: string | string[]): Promise<IFintooResponse> {
    return cleartaxAxios
      .get(`/f/fintoo/get_user_details?user_id=${user_id}`)
      .then((data) => {
        return data.data.data;
      })
      .catch((err) => console.log(err));
  }
  niyoSignup(code: string | string[]): Promise<IFintooResponse> {
    return cleartaxAxios
      .get(`/f/niyo/get_user_details?code=${code}`)
      .then((data) => {
        return data.data;
      })
      .catch((err) => console.log(err));
  }
  onePercentSignup(token: string | string[]): Promise<IFintooResponse> {
    return cleartaxAxios
      .get(`/f/one-percent/auth?token=${token}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => console.log(err));
  }
  ltFinanceSignup(code: string | string[]): Promise<IFintooResponse> {
    return cleartaxAxios
      .get(`/f/lt-finance/get-user-details?code=${code}`)
      .then((data) => {
        const parsedData = data?.data['code'];
        setSessionCookie('phoneNo', parsedData);
        return data.data;
      })
      .catch((err) => console.log(err));
  }
  partnerSignup(queryString: string | string[]): Promise<IFintooResponse> {
    return cleartaxAxios
      .get(`/f/partner-redirection${queryString}`)
      .then((data) => {
        return data.data.data;
      })
      .catch((err) => console.log(err));
  }
}
export default new PartnerPageDataService();
